var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visa_container"},[_c('div',{staticClass:"visa_top_title"},[_vm._v("\n        Visa processing of  "),_c('span',[_vm._v(" "+_vm._s(_vm.visa.name))])]),_vm._v(" "),_c('div',{staticClass:"visa_detail_container"},[_c('VisaProfile'),_vm._v(" "),_c('VisaCard')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a0b5d8c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/VisaDetail.vue
// module id = null
// module chunks = 